module.exports = __webpack_public_path__ + "static/img/数字孪生系统开发.8a0f0792.png";